<script setup>
const props = defineProps(['doctor']); 
const emits = defineEmits(['edit', 're-upload', 'upload', 'openModal']);

// modal hookups
function openModal(type) {
  emits('openModal', props.doctor, type);
}
</script>
<template>
  <div class="container">
    <div class="name">{{ doctor.name }}</div>
    <div class="completed">
      <div v-if="doctor.scheduleUploaded">
        <button class="edit" @click="">Edit</button>
        <button class="re-upload" @click="openModal('re-upload')">Re-Upload</button>
      </div>
      <div v-else>
        <button @click="openModal('upload')">Upload</button>
        </div>

    </div>
  </div>
</template>
<style scoped lang="scss">
.container{
  display: flex;
  align-items: center;
  // justify-content: center;
  height: 4rem;
  border: 1px solid #ccc;

  &:hover {
    background-color: #f5f5f5; // Change this to the color you want
  }
  .upload-exists{
    display: flex;
    .edit{
      flex: 1;
    }
    .re-upload{
      flex: 1;
    }
  }
  .name {
    flex: 6;
    text-align: center;
  }

  .completed {
    flex: 4;
    text-align: center;
  }

}

button{
  border: none;
  background-color: #673ab7;
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  margin: 0 0.5rem;
  cursor: pointer;

}
</style>